import API from 'app/api';

const fetchDeltaConfig = ({ offerId, campaignId }) =>
  API.DeltaConfig.fetchDeltaConfig({
    app_version: window.etp.appVersion,
    offer_id: offerId,
    campaign_id: campaignId,
  });

export { fetchDeltaConfig };
